import { BaseService } from './base.service'

import axios from '@axios'

import { ResponseWrapper, ErrorWrapper } from './util'

export class ParamSystemService extends BaseService {
  static get entity () {
    return '/mastering/systemParameter'
  }
}